import { render } from "./index.vue?vue&type=template&id=13c570ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=13c570ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13c570ba"

export default script